import { CustomModal } from 'components/uikit/modal/CustomModal';
import { useScopedTranslation } from 'application/localization/useScopedTranslation';
import { BaseNode } from 'helpers/documents/types/base';
import { EditItemModal } from '../../editItem/EditItemModal';
import { DocumentTreeItemProps } from './types.ts';

type TreeItemEditModalProps = {
  isOpen: boolean;
  onClose: () => void;
  item: BaseNode;
  parent: DocumentTreeItemProps['parent'];
  onSubmit: (name: string) => void;
};

export const TreeItemEditModal = ({
  isOpen,
  onClose,
  item,
  parent,
  onSubmit,
}: TreeItemEditModalProps) => {
  const editModalTitle = useScopedTranslation('Component.EditFolderModal');
  const enumsI18n = useScopedTranslation('Enums');

  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      isBlocking={true}
      title={editModalTitle.t('edit_title', {
        itemType: enumsI18n.t(`NodeType.${item.type}`).toLowerCase(),
      })}
    >
      <EditItemModal
        id={item.id}
        name={item.name}
        folders={parent ? parent.children! : [item]}
        onClose={onClose}
        onFolderSubmit={onSubmit}
        onFileSubmit={onSubmit}
      />
    </CustomModal>
  );
};
